import { SessionProgram } from './session-program';
import { FmRelease } from './fm-release';
import { Group } from './group';

export class SessionDetails {
  id: number;
  program: SessionProgram;
  timezone: string;
  automatic: boolean;
  name: string;
  start_date: string;
  end_date: string;
  joining_opens: string;
  joining_closes: string;
  user_cap: number;
  filled: boolean;
  user_count: number;
  min_team_size: number;
  team_name_prefix: string;
  team_name_lists: string[];
  fm_releases: FmRelease[];
  teams: Group[];
  scheduled?: boolean;
  group_set_id: number;
  future: boolean;
  joinable: boolean;
  current: boolean;
  launched: boolean;
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/program/session-details.ts